import React, { useState, Component } from 'react';
import { MessageSquareIcon, ArrowRightIcon, XIcon, SendIcon, MailIcon } from 'lucide-react';
export function FooterUtilityBar() {
  const [email, setEmail] = useState('');
  const [emailError, setEmailError] = useState('');
  const [showFeedbackForm, setShowFeedbackForm] = useState(false);
  const [showSupportForm, setShowSupportForm] = useState(false);
  const [feedbackText, setFeedbackText] = useState('');
  const [supportText, setSupportText] = useState('');
  const handleEmailChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const value = e.target.value;
    setEmail(value);
    if (value && !value.includes('@')) {
      setEmailError("Please include an '@' in the email address.");
    } else {
      setEmailError('');
    }
  };
  const handleSubscribe = (e: React.FormEvent) => {
    e.preventDefault();
    if (!email) return setEmailError('Please enter your email.');
    if (!email.includes('@')) return setEmailError("Please include an '@' in the email address.");
    alert(`Thank you for subscribing with: ${email}`);
    setEmail('');
    setEmailError('');
  };
  const handleFeedbackSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    window.location.href = `mailto:info@joinemigo.com?subject=Feedback for Emigo&body=${encodeURIComponent(feedbackText)}`;
    setShowFeedbackForm(false);
    setFeedbackText('');
  };
  const handleSupportSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    window.location.href = `mailto:info@joinemigo.com?subject=Support Request&body=${encodeURIComponent(supportText)}`;
    setShowSupportForm(false);
    setSupportText('');
  };
  return <>
      <footer style={{
      backgroundColor: 'var(--navy-deep)'
    }} data-id="element-94">
        <div className="max-w-6xl mx-auto px-6 sm:px-8 lg:px-10 py-10 md:py-12" data-id="element-95">
          {/* Top: brand + tagline */}
          <div className="flex flex-col md:flex-row md:items-center justify-between gap-4 mb-8 pb-6" style={{
          borderBottom: '1px solid rgba(255,255,255,0.08)'
        }} data-id="element-96">
            <div className="flex items-center gap-4 flex-wrap" data-id="element-97">
              <div className="flex items-center gap-2" data-id="element-98">
                <img src="https://cdn.magicpatterns.com/uploads/kPyEtui4sL9gCL5rPK2NdZ/Emigo_Icon_(1)-modified.png" alt="" className="w-7 h-7 rounded-full" aria-hidden="true" data-id="element-99" />
                <span className="text-xl font-normal text-white" style={{
                fontFamily: "'DM Serif Display', serif"
              }} data-id="element-100">
                  Emigo
                </span>
              </div>
              <span className="hidden sm:inline text-slate-500 text-sm" data-id="element-101">
                A calmer layer between you and your messages.
              </span>
            </div>

            {/* Social icons */}
            <div className="flex items-center gap-4" data-id="element-102">
              <a href="https://www.instagram.com/emigo.us/" target="_blank" rel="noopener noreferrer" className="text-slate-400 hover:text-white transition-colors" aria-label="Instagram" data-id="element-103">
                <svg className="h-5 w-5" fill="currentColor" viewBox="0 0 24 24" data-id="element-104">
                  <path d="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zM12 0C8.741 0 8.333.014 7.053.072 2.695.272.273 2.69.073 7.052.014 8.333 0 8.741 0 12c0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98C8.333 23.986 8.741 24 12 24c3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98C15.668.014 15.259 0 12 0zm0 5.838a6.162 6.162 0 100 12.324 6.162 6.162 0 000-12.324zM12 16a4 4 0 110-8 4 4 0 010 8zm6.406-11.845a1.44 1.44 0 100 2.881 1.44 1.44 0 000-2.881z" data-id="element-105" />
                </svg>
              </a>
              <a href="https://www.tiktok.com/@emigo.us" target="_blank" rel="noopener noreferrer" className="text-slate-400 hover:text-white transition-colors" aria-label="TikTok" data-id="element-106">
                <svg className="h-5 w-5" fill="currentColor" viewBox="0 0 24 24" data-id="element-107">
                  <path d="M12.525.02c1.31-.02 2.61-.01 3.91-.02.08 1.53.63 3.09 1.75 4.17 1.12 1.11 2.7 1.62 4.24 1.79v4.03c-1.44-.05-2.89-.35-4.2-.97-.57-.26-1.1-.59-1.62-.93-.01 2.92.01 5.84-.02 8.75-.08 1.4-.54 2.79-1.35 3.94-1.31 1.92-3.58 3.17-5.91 3.21-1.43.08-2.86-.31-4.08-1.03-2.02-1.19-3.44-3.37-3.65-5.71-.02-.5-.03-1-.01-1.49.18-1.9 1.12-3.72 2.58-4.96 1.66-1.44 3.98-2.13 6.15-1.72.02 1.48-.04 2.96-.04 4.44-.99-.32-2.15-.23-3.02.37-.63.41-1.11 1.04-1.36 1.75-.21.51-.15 1.07-.14 1.61.24 1.64 1.82 3.02 3.5 2.87 1.12-.01 2.19-.66 2.77-1.61.19-.33.4-.67.41-1.06.1-1.79.06-3.57.07-5.36.01-4.03-.01-8.05.02-12.07z" data-id="element-108" />
                </svg>
              </a>
            </div>
          </div>

          {/* 3 columns */}
          <div className="grid grid-cols-1 md:grid-cols-3 gap-6 md:gap-0" data-id="element-109">
            {/* Feedback */}
            <div className="md:pr-8 lg:pr-10" data-id="element-110">
              <h3 className="text-white text-xs font-semibold mb-2 uppercase" style={{
              letterSpacing: '0.08em'
            }} data-id="element-111">
                Help improve Emigo
              </h3>
              <p className="text-slate-400 text-xs mb-3 leading-relaxed" data-id="element-112">
                Your feedback shapes what we build next.
              </p>
              <button onClick={() => setShowFeedbackForm(true)} className="inline-flex items-center px-4 py-2 rounded-full border text-white text-sm font-medium transition-all hover:bg-white/5" style={{
              borderColor: 'rgba(255,255,255,0.2)'
            }} data-id="element-113">
                <MessageSquareIcon className="w-4 h-4 mr-2" data-id="element-114" />
                Give feedback
              </button>
            </div>

            {/* Subscribe */}
            <div className="md:px-8 lg:px-10" style={{
            borderLeft: '1px solid rgba(255,255,255,0.08)',
            borderRight: '1px solid rgba(255,255,255,0.08)'
          }} data-id="element-115">
              <h3 className="text-white text-xs font-semibold mb-2 uppercase" style={{
              letterSpacing: '0.08em'
            }} data-id="element-116">
                Get updates
              </h3>
              <p className="text-slate-400 text-xs mb-3 leading-relaxed" data-id="element-117">
                Occasional notes on what we're building.
              </p>
              <form onSubmit={handleSubscribe} data-id="element-118">
                <div className="flex gap-2" data-id="element-119">
                  <div className="relative flex-1" data-id="element-120">
                    <input type="email" value={email} onChange={handleEmailChange} className="w-full px-4 py-2 rounded-full text-white placeholder-slate-500 text-sm focus:outline-none transition-colors" style={{
                    backgroundColor: 'rgba(255,255,255,0.06)',
                    border: '1px solid rgba(255,255,255,0.12)'
                  }} placeholder="you@email.com" autoComplete="email" data-id="element-121" />
                    {emailError && <div className="absolute -bottom-6 left-0 text-xs text-red-400" data-id="element-122">
                        {emailError}
                      </div>}
                  </div>
                  <button type="submit" className="px-5 py-2 text-white text-sm font-semibold rounded-full transition-all hover:opacity-90 flex-shrink-0" style={{
                  backgroundColor: 'var(--coral)'
                }} data-id="element-123">
                    <ArrowRightIcon className="h-4 w-4" data-id="element-124" />
                  </button>
                </div>
              </form>
            </div>

            {/* Support + Legal */}
            <div className="md:pl-8 lg:pl-10" data-id="element-125">
              <h3 className="text-white text-xs font-semibold mb-2 uppercase" style={{
              letterSpacing: '0.08em'
            }} data-id="element-126">
                Need help?
              </h3>
              <p className="text-slate-400 text-xs mb-3 leading-relaxed" data-id="element-127">
                We're here if you have questions.
              </p>
              <button onClick={() => setShowSupportForm(true)} className="inline-flex items-center text-slate-300 text-sm font-medium hover:text-white transition-colors mb-3" data-id="element-128">
                <MailIcon className="w-4 h-4 mr-2" data-id="element-129" />
                Contact support
              </button>
              <div className="flex items-center gap-3 pt-3" style={{
              borderTop: '1px solid rgba(255,255,255,0.08)'
            }} data-id="element-130">
                <a href="/terms-of-service" className="text-slate-500 text-xs hover:text-slate-300 transition-colors" data-id="element-131">
                  Terms
                </a>
                <span className="text-slate-700 text-xs" data-id="element-132">·</span>
                <a href="/privacy-policy" className="text-slate-500 text-xs hover:text-slate-300 transition-colors" data-id="element-133">
                  Privacy
                </a>
              </div>
            </div>
          </div>

          {/* Copyright */}
          <div className="mt-8 pt-5 text-center" style={{
          borderTop: '1px solid rgba(255,255,255,0.06)'
        }} data-id="element-134">
            <span className="text-slate-500 text-xs" data-id="element-135">
              &copy; {new Date().getFullYear()} Emigo&trade; — Say what you
              mean.
            </span>
          </div>
        </div>
      </footer>

      {/* Feedback Modal */}
      {showFeedbackForm && <div className="fixed inset-0 z-50 overflow-y-auto flex items-center justify-center p-4 bg-black/50" data-id="element-136">
          <div className="rounded-2xl shadow-xl max-w-md w-full p-6" style={{
        backgroundColor: 'var(--cream)'
      }} data-id="element-137">
            <div className="flex justify-between items-center mb-6" data-id="element-138">
              <h2 className="text-xl font-normal" style={{
            color: 'var(--navy)',
            fontFamily: "'DM Serif Display', serif"
          }} data-id="element-139">
                Share your feedback
              </h2>
              <button onClick={() => {
            setShowFeedbackForm(false);
            setFeedbackText('');
          }} className="text-gray-500 hover:text-gray-700 transition-colors" data-id="element-140">
                <XIcon className="w-5 h-5" data-id="element-141" />
              </button>
            </div>
            <form onSubmit={handleFeedbackSubmit} className="space-y-4" data-id="element-142">
              <textarea value={feedbackText} onChange={e => setFeedbackText(e.target.value)} rows={6} className="w-full px-3 py-2 rounded-lg focus:outline-none" style={{
            border: '1px solid var(--border-soft)',
            backgroundColor: '#FFFFFF',
            color: 'var(--navy)'
          }} placeholder="How can we improve Emigo?" required data-id="element-143" />
              <div className="flex justify-end gap-3 pt-2" data-id="element-144">
                <button type="button" onClick={() => {
              setShowFeedbackForm(false);
              setFeedbackText('');
            }} className="px-4 py-2 rounded-full text-sm" style={{
              border: '1px solid var(--border-soft)',
              color: 'var(--navy)'
            }} data-id="element-145">
                  Cancel
                </button>
                <button type="submit" className="px-4 py-2 rounded-full text-white text-sm flex items-center" style={{
              backgroundColor: 'var(--coral)'
            }} data-id="element-146">
                  Send <SendIcon className="ml-2 h-4 w-4" data-id="element-147" />
                </button>
              </div>
            </form>
          </div>
        </div>}

      {/* Support Modal */}
      {showSupportForm && <div className="fixed inset-0 z-50 overflow-y-auto flex items-center justify-center p-4 bg-black/50" data-id="element-148">
          <div className="rounded-2xl shadow-xl max-w-md w-full p-6" style={{
        backgroundColor: 'var(--cream)'
      }} data-id="element-149">
            <div className="flex justify-between items-center mb-6" data-id="element-150">
              <h2 className="text-xl font-normal" style={{
            color: 'var(--navy)',
            fontFamily: "'DM Serif Display', serif"
          }} data-id="element-151">
                Contact support
              </h2>
              <button onClick={() => {
            setShowSupportForm(false);
            setSupportText('');
          }} className="text-gray-500 hover:text-gray-700 transition-colors" data-id="element-152">
                <XIcon className="w-5 h-5" data-id="element-153" />
              </button>
            </div>
            <form onSubmit={handleSupportSubmit} className="space-y-4" data-id="element-154">
              <textarea value={supportText} onChange={e => setSupportText(e.target.value)} rows={6} className="w-full px-3 py-2 rounded-lg focus:outline-none" style={{
            border: '1px solid var(--border-soft)',
            backgroundColor: '#FFFFFF',
            color: 'var(--navy)'
          }} placeholder="How can we help you?" required data-id="element-155" />
              <div className="flex justify-end gap-3 pt-2" data-id="element-156">
                <button type="button" onClick={() => {
              setShowSupportForm(false);
              setSupportText('');
            }} className="px-4 py-2 rounded-full text-sm" style={{
              border: '1px solid var(--border-soft)',
              color: 'var(--navy)'
            }} data-id="element-157">
                  Cancel
                </button>
                <button type="submit" className="px-4 py-2 rounded-full text-white text-sm flex items-center" style={{
              backgroundColor: 'var(--coral)'
            }} data-id="element-158">
                  Send <SendIcon className="ml-2 h-4 w-4" data-id="element-159" />
                </button>
              </div>
            </form>
          </div>
        </div>}
    </>;
}
export default FooterUtilityBar;